module.exports = __webpack_public_path__ + "static/media/valor2.e7a6db91.gif";